<style>
.kt-user-card-avatar-hover:hover {
  opacity: 0.6;
  cursor: pointer;
}
.kt-notification__item-time.quebra {
  margin-top: 10px;
}
.titulo_modal {
  text-align: center;
  margin-bottom: 20px;
  font-size: 14px;
}
</style>

<template>
  <div>
    <!--begin: Head -->
    <v-file-input
      id="input-upload-foto"
      type="file"
      style="display: none"
      label="imagemPerfil"
      accept="image/png, image/jpeg, image/jpg image/bmp, image/webp"
      class="mb-2"
      @change="atualizarImagemPerfil"
      v-model="arquivo"
    >
    </v-file-input>

    <div
      @click="clickUploadArquivo"
      class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
      :style="{ backgroundImage: `url(${backgroundImage})` }"
    >
      <div class="kt-user-card__avatar kt-user-card-avatar-hover">
        <img
          v-if="usuario.usuario.caminhoVisualizacao"
          alt="Pic"
          :src="usuario.usuario.caminhoVisualizacao"
        />
        <!--use below badge element instead the user avatar to display username's first letter(remove kt-hidden class to display it) -->
        <span
          v-if="!usuario.usuario.caminhoVisualizacao"
          class="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success"
          >{{ usuario.usuario.nome.substr(0, 1) }}</span
        >
      </div>
      <div class="kt-user-card__name">{{ usuario.usuario.nome }}</div>
      <div class="kt-user-card__badge"></div>
    </div>
    <!--end: Head -->

    <!--begin: Navigation -->
    <div class="kt-notification">
      <a
        href="#"
        v-on:click="abrirDialogAlterarSenha"
        class="kt-notification__item--no-after"
      >
        <div class="kt-notification__item-icon">
          <i class="flaticon2-lock text-warning"></i>
        </div>
        <div class="kt-notification__item-title kt-font-bold">
          Alterar Senha de Acesso
        </div>
      </a>
      <a
        href="#"
        v-on:click="alterarFusoDialog = true"
        class="kt-notification__item--no-after"
      >
        <div class="kt-notification__item-icon">
          <i class="flaticon-time-1 text-warning"></i>
        </div>
        <div class="kt-notification__item-title kt-font-bold">
          Alterar Fuso Horário
        </div>
      </a>
      <a
        href="https://bigcore.zendesk.com/hc/pt-br"
        target="_blank"
        class="kt-notification__item--no-after"
      >
        <div class="kt-notification__item-icon">
          <i class="flaticon2-information kt-font-info"></i>
        </div>
        <div class="kt-notification__item-title kt-font-bold">Ajuda</div>
      </a>

      <a
        href="mailto:suporte.ged@bigcore.com.br"
        target="_blank"
        class="kt-notification__item--no-after"
      >
        <div class="kt-notification__item-icon">
          <i class="flaticon-support kt-font-info"></i>
        </div>
        <div class="kt-notification__item-title kt-font-bold">
          Abrir um Chamado
        </div>
      </a>

      <div class="kt-notification__custom kt-space-between">
        <a
          v-on:click="onLogout()"
          class="btn btn-label btn-label-brand btn-sm btn-bold"
          >Sair</a
        >
      </div>
    </div>
    <!--end: Navigation -->

    <!-- Modal-->
    <v-dialog v-model="dialog" persistent max-width="320px">
      <v-card>
        <div class="titulo_modal">
          <br />
          <span>Por favor informe a NOVA SENHA de Acesso</span>
        </div>

        <v-form v-model="valid" ref="form">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Senha"
                  outlined
                  v-model="password"
                  class="campo_texto"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.passwordMinSize]"
                  :type="show1 ? 'text' : 'password'"
                  name="password"
                  @click:append="show1 = !show1"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  label="Repetir Senha"
                  outlined
                  class="campo_texto"
                  v-model="confirm_password"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[
                    rules.required,
                    rules.passwordMinSize,
                    passwordMatch,
                  ]"
                  :type="show1 ? 'text' : 'password'"
                  name="confirm-password"
                  @click:append="show1 = !show1"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <v-card-actions>
          <div
            style="text-align: center; margin-left: 50px; margin-bottom: 20px"
          >
            <v-btn
              color="green darken-2"
              style="margin-right: 10px"
              @click="updatePasswordUser"
            >
              <span style="color: white">Salvar</span>
            </v-btn>

            <v-btn outlined color="primary" @click="dialog = false">
              <span style="color: black">Fechar</span>
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="alterarFusoDialog" persistent max-width="320px">
      <v-card>
        <div class="titulo_modal">
          <br />
          <span>Alterar Fuso Horário</span>
        </div>

        <v-form v-model="valid" ref="form">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select
                  :items="timezones"
                  label="Fuso Horário"
                  item-text="descricao"
                  item-value="id"
                  v-model="this.usuario.login.timezoneID"
                  required
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <v-card-actions>
          <div
            style="text-align: center; margin-left: 50px; margin-bottom: 20px"
          >
            <v-btn
              color="green darken-2"
              style="margin-right: 10px"
              @click="updateTimezone"
            >
              <span style="color: white">Salvar</span>
            </v-btn>

            <v-btn outlined color="primary" @click="alterarFusoDialog = false">
              <span style="color: black">Fechar</span>
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { LOGOUT } from "@/store/auth.module";
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import { SET_AUTH } from "@/store/auth.module";

export default {
  name: "KTDropdownUser",
  data() {
    return {
      dialog: false,
      show: false,
      show1: false,
      alterarFusoDialog: false,
      valid: false,
      password: "",
      confirm_password: "",
      usuario: { usuario: { nome: "" }, login: { timezoneID: 1 } },
      cliente: {},
      arquivo: null,
      timezones: [],
      rules: {
        required: (v) => !!v || "Obrigatório",
        passwordMinSize: (v) =>
          v.length >= 6 || "A senha deve ter 6 caracteres no mínimo",
      },
    };
  },

  methods: {
    onLogout() {
      window.localStorage.clear();
      sessionStorage.clear();
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
    },

    abrirDialogAlterarSenha() {
      this.password = "";
      this.confirm_password = "";
      this.dialog = true;
    },

    clickUploadArquivo() {
      document.getElementById("input-upload-foto").click();
    },

    async updatePasswordUser() {
      if (this.$refs.form.validate()) {
        this.dialog = false;
        return new Promise((resolve) => {
          ApiService.put("usuario/AlterarSenha", {
            email: this.usuario.login.email,
            senha: this.password,
          }).then(({ data }) => {
            resolve(data);
            Swal.fire({
              position: "center",
              icon: data.success == true ? "success" : "error",
              title:
                data.success == true
                  ? "Senha alterada com sucesso"
                  : data.errors.join(", "),
              showConfirmButton: false,
              timer: data.success == true ? 5000 : 1500,
            });
          });
        });
      }
    },
    async updateTimezone() {
      return new Promise((resolve) => {
        ApiService.put(
          `login/alterar-timezone/${this.usuario.login.timezoneID}`
        ).then(({ data }) => {
          resolve(data);
          this.$store.commit(SET_AUTH, data);
          window.localStorage.setItem(
            "cliente",
            JSON.stringify(data.data.cliente)
          );
          this.alterarFusoDialog = false;
        });
      });
    },
    async listarTimezones() {
      const { data: result } = await ApiService.get("timezone");
      if (result.success) this.timezones = result.data;
      else SweetAlert.sweetAlertError(result.errors);
    },
    async atualizarImagemPerfil() {
      if (this.arquivo == null) return;

      const formData = new FormData();
      formData.append("arquivo", await this.arquivo);
      formData.set("clienteID", this.cliente.id);
      formData.set("usuarioID", this.usuario.usuario.id);

      const { data: result } = await ApiService.put(
        "usuario/AtualizarImagemPerfil",
        formData
      );

      Swal.fire({
        position: "center",
        icon: "success",
        title: "Imagem do Perfil Atualizada com sucesso!",
        showConfirmButton: false,
        timer: 1500,
      });

      this.usuario.usuario.caminhoVisualizacao = result.data;
    },
  },

  computed: {
    backgroundImage() {
      return process.env.BASE_URL + "assets/media/misc/bg-1.jpg";
    },

    passwordMatch() {
      return () =>
        this.password === this.confirm_password || "As senhas devem ser iguais";
    },
  },

  mounted() {
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.usuario = JSON.parse(window.localStorage.getItem("usuario"));
    if (this.usuario == null) {
      this.usuario = {
        usuario: {
          nome: "",
        },
        login: { timezoneID: 1 },
      };
    }
    if (JSON.parse(window.localStorage.getItem("usuario"))) {
      this.listarTimezones();
    }
    
  },
};
</script>
